
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqMnSwTwKzYcMOUhjpkQnZev74Ma1ZE5fcR0M5S7E3SY4Meta } from "/codebuild/output/src218338103/src/src/pages/faq.vue?macro=true";
import { default as menuhdWLhKBDuH3sIergpMYHnTZyDmEdU75PU88TYQGvL1IMeta } from "/codebuild/output/src218338103/src/src/pages/menu.vue?macro=true";
import { default as indexlGzdbNGUkcfkedZY_cvGNjG1TF6b8SFHDdMQoCrfk4MMeta } from "/codebuild/output/src218338103/src/src/pages/index.vue?macro=true";
import { default as contactRjG1TnKlsdGyS4mmukTq1AZ6AYSakJj9yXV2Tdi_45OlQMeta } from "/codebuild/output/src218338103/src/src/pages/contact.vue?macro=true";
import { default as tutorial5AAwestNRv7I1kvFGpFH10UjkDofHUVE21s7QGusG68Meta } from "/codebuild/output/src218338103/src/src/pages/tutorial.vue?macro=true";
import { default as agreementJQFVQp93_iWNz4TBhji10Q7IuadVh6ueUZSTaqt4imsMeta } from "/codebuild/output/src218338103/src/src/pages/agreement.vue?macro=true";
import { default as about_45passHA7QfbeH0_ws2S0C5PSOxd7WYDWGCjypdMObm_w6YeIMeta } from "/codebuild/output/src218338103/src/src/pages/about-pass.vue?macro=true";
import { default as indexuYU4iRkE7R_45oOzOFBJYyxPl9HzXdJ7qKCKjbSzNBRn4Meta } from "/codebuild/output/src218338103/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93_45dEpRCCKrIEeGyuHKR2Ckx3Izq36qcYDyL569MAYzdMMeta } from "/codebuild/output/src218338103/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceNJoRD7JlYYy_m0YC5Jd6e_yetm7VdREfRc8Zuard0dQMeta } from "/codebuild/output/src218338103/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93jPaG9nsjfNyND6fz587XzK0fL0Lbwlxw5vWwq8ZdqfEMeta } from "/codebuild/output/src218338103/src/src/pages/notice/[id].vue?macro=true";
import { default as index4wt3yio8o_45ERvJCERBmqFClwj8548fz_45zj6QxBJgabUMeta } from "/codebuild/output/src218338103/src/src/pages/coupon/index.vue?macro=true";
import { default as indexb6wirZrLJRRAq5N9uutQouWgYsVTtDB_45v_KZXcCrTnkMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/index.vue?macro=true";
import { default as indexwv6mprOsuV_451AsI9qUVT5PIhkV5_45ExjdSvQV0iu4a8YMeta } from "/codebuild/output/src218338103/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93LDteRt9YMhbRIixRiC4hXpJtwkpgn5zDe3x7gBuiO4cMeta } from "/codebuild/output/src218338103/src/src/pages/parking/[id].vue?macro=true";
import { default as indexdfv7NwCMP1fNPjrNNTGDrwNslbZqtCmZF_TFVnLtzaEMeta } from "/codebuild/output/src218338103/src/src/pages/history/index.vue?macro=true";
import { default as indexlxgL_45BxfHbb5rr0OEGO50w3V78QEi1von7AQoGycE48Meta } from "/codebuild/output/src218338103/src/src/pages/monthly/index.vue?macro=true";
import { default as indexaE5ooqXjRMrCE7dymDzwtRS3V0SAFtPaJbJn9OJse2sMeta } from "/codebuild/output/src218338103/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexDbNYiFuPsUVrzJBZBlcYmuajKzwGnv3RGoQfQXsr8GQMeta } from "/codebuild/output/src218338103/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavio1Hiq25RZ_45WizQAjAib4pOvl_bwG2HHe6Lb5ZLd4DJUMeta } from "/codebuild/output/src218338103/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editViQfdasm_45VquJT8ECAV80ztalTnMdTlJ_45wff3E1BKdwMeta } from "/codebuild/output/src218338103/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementA0C1WipyLASm3ThFhEzIRDyYS5vXTVtgPqAnROtZMV8Meta } from "/codebuild/output/src218338103/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexqckzb2HuPQma1Fdegb2oUqI_45XW_HVsu1wkHaDXylTysMeta } from "/codebuild/output/src218338103/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d4KrrMo5krlYCU4t2OlaPIoKyBfelAx6ds2cj9UEhZHMMeta } from "/codebuild/output/src218338103/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm1m2OUxD_FuorVMJQrDkntY05xm_KQ6sdvuO5_45nDQCUEMeta } from "/codebuild/output/src218338103/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexy5GTIby4E_K3JsIfptDBEi_V1D_45s7f2RbF8mOp99k20Meta } from "/codebuild/output/src218338103/src/src/pages/card/create/index.vue?macro=true";
import { default as index_45quQxt97hzbKbRMajelI2a3y61oXgJHpLD9l2keWKDUMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmKXc7Kh_45XYVTiu0hO4Uipqs9rK_wAULmZEsdvl_8YmxAMeta } from "/codebuild/output/src218338103/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmA_45haJh7PnJfDul6lJwNz2Dp_BveWRkMstZsetaKqhsMMeta } from "/codebuild/output/src218338103/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_454fZSef0JT9Izlz2YhQN2XK0NuL2hhyys1rkMovYeQcMeta } from "/codebuild/output/src218338103/src/src/pages/membership/complete.vue?macro=true";
import { default as register_N4gBgVddK1U_45OWFrJgPY82ZPGK2wcTNbIWIxBMuZ40Meta } from "/codebuild/output/src218338103/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Tvnbu_456igwTybQ92okUHj3dmUiAP8CeKQO8mTmj1QFAMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmgGn0VbcT0GXSTWEjWQx4LA14IAK6yK6Va6IQX6yjw4MMeta } from "/codebuild/output/src218338103/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93CXELUavPdUghuvPw_45JnXHOdVIBMHA2Dt_45wFXiff2gTAMeta } from "/codebuild/output/src218338103/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexFOFYnPcVBm5jAk_45GfXOn3ar5x5dhbECqLYWsjM2FbToMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code_ZfFj9i9lHSUpg0xoKH6_Kh6WqYKjozrJe4NdvIH9dsMeta } from "/codebuild/output/src218338103/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code6QtV3rDi7u9TuRkfFtCvuWTKZoMtVPZMlf8f7rH0t5AMeta } from "/codebuild/output/src218338103/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeuo_45mQSJWMUF58FaR9bSGP36HMcf1vsZDnb2VZijaytIMeta } from "/codebuild/output/src218338103/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerADvBt7hOATTG4zdOIQbYBrD9u_45und9YZUpigJzq34CYMeta } from "/codebuild/output/src218338103/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeL9xAZ7XpTooq6W3p4MV2Qm_ylpkL3kz7j6g2EGXfVoIMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexEB94fl_45lX4XdOBv1i5zgRRraMl5PFhWMtBfF8pfd9KIMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm3zqtq04YhxTSbEMpcTlc0LEacvERPS5F17RqyKH4P8MMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completevOl4LcDymjcGTAplcgqHwMy8xXmh3NeqI4pJwMlviDsMeta } from "/codebuild/output/src218338103/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index_45i1zlKVAP9QTmWqrOJ_45D1J1J4G6_45P49_45qrZw0Qi7D2EMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93wNsJLfeg7c38kY9PAGAjamWArs_SLtZBT4Fym9yTLgEMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeURMQxdIfxocwip6zjuDeIPd4jieQvkRjdZWC36A82NIMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasgQp4D_SOoOhqZoJ6OksW9Lj_45mt_QoxM1WY0Be6NcNbYMeta } from "/codebuild/output/src218338103/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplexiomCDIolxo2E513RsRCGkD4SIafxIPlHwCpJmBIJFQMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailsR09XGaXMfUQrQJq2N4w_45T0n8oqhuO_457zk6O_45RNra6oMeta } from "/codebuild/output/src218338103/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm2GN5W2MREjnunlY5N5bHqJVh9nO2ieFQANGX3INiKF4Meta } from "/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentgq_45eP4DqaEPYiAJkp9MRSOWX43RpDKjsUVyVfWTOjs0Meta } from "/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_pwFbe82EDgHsX4qeYi43PqcLTUsFr7M3i4_45sIebWFQMeta } from "/codebuild/output/src218338103/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate_450RrEYW_R_45Cccn_IwKQajsYgpV6HdwDZ7GwKclpBdUIMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeBlQggwpRFnouWc8RIwRsGYdYjL9HQ1NkJRZhsVE_u08Meta } from "/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeSb2TJIv7ciXPaQZxFhLqju9uyL7zkWAD8fHQT7whhJgMeta } from "/codebuild/output/src218338103/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordB1bWqXni5aFD3hT9qnSnGPw1dyo3nzENn6fLVfjaCxcMeta } from "/codebuild/output/src218338103/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasPr95kahx7mjpSGE_BTDviZtFKVGEukrIAiTrXhlJWFUMeta } from "/codebuild/output/src218338103/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register4go_7uivi3GDLwQMajzZkkd6wm2hirVZRGeV46yNCOMMeta } from "/codebuild/output/src218338103/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeKM_9Hr_45GbdCeqAk_VQ2cANkcXkdZuHi17V_45w_45KlSs0kMeta } from "/codebuild/output/src218338103/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexkv_45JCjbATAl0F_459jpO7irz3Oq7bZhv5CJryK7HXYAMQMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexUyEIViJ8pl6u2UnGaBAJLasyDxgMcazTe4u4Msi99gcMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexd_45Y_1T_45o1sBJDaTmp18vvYMz1IJltXj3rG_45v2yweebUMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index4AxkiRjWnDE6cF3_45njPk4fnj0y0mHw22FE2m_MpIt1gMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update3N8N91omX5ettdcWmeSFeKD117kY2kJBEjinjr4CJHMMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeqB5MAOwtiR2FDqN2K6hn0NQngzxAJd49yGa1vPCZQusMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmfhI9aB2ixcctnV26Vvv29qNyQnxdP4DUFxnyAkBHbPAMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index3DxP9ZAhlqN7VZArFPbqi_45Vs1Zze9TWgB8on144ufQEMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completelcGuw7P6UcbDSpYpPRKdpKKlKcmo5eornD13bTxQoRoMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateq8I8WR5j05z2mxZUaFCrM5Luek2mi3Wz1JtWqrIpppwMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexyoac0YC1MuNNiN6DsLK69GL4zPEQ52eYdW9W99vDPocMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJoBAJ_45xUMpUmrIEgpyTYOKPr4xHqjinYY_45aWuBt2etwMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeLs3o6AdeuqNO4oSWjbHjdrwHXsWNc4BqMXS36a5PF8kMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexVreAQ6zLaqQak1J3eInaAf4qBYWDoy2VPJxN_45E4oNLcMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codedWq272b_45tqb78Msu3LTG1D9d7c3y3ToLINatvMinsM8Meta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexrfXlmyuHczcOzOX29D0dqJlNI_pkh_455tHqF5vpH6Su8Meta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index1bk6UiV2v_SCC1MsmqIM3VRsTBdqJpqSEyvooaQ0GB4Meta } from "/codebuild/output/src218338103/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexfd7QRPbg_45eZBSDXNch_45ddxP0sLEZj98hCTdnwKIx6AkMeta } from "/codebuild/output/src218338103/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateqSv7TEmi7vxFFN2fS1cCi5wz2B7cZPNX6tD6W48_TeUMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm_45lts5IXsHw4_ZsSNW4Xz4TfDitqQXbPX_e1_cdjYqlAMeta } from "/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src218338103/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuhdWLhKBDuH3sIergpMYHnTZyDmEdU75PU88TYQGvL1IMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlGzdbNGUkcfkedZY_cvGNjG1TF6b8SFHDdMQoCrfk4MMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src218338103/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src218338103/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src218338103/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src218338103/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src218338103/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index4wt3yio8o_45ERvJCERBmqFClwj8548fz_45zj6QxBJgabUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexdfv7NwCMP1fNPjrNNTGDrwNslbZqtCmZF_TFVnLtzaEMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexaE5ooqXjRMrCE7dymDzwtRS3V0SAFtPaJbJn9OJse2sMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexDbNYiFuPsUVrzJBZBlcYmuajKzwGnv3RGoQfQXsr8GQMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src218338103/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src218338103/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexy5GTIby4E_K3JsIfptDBEi_V1D_45s7f2RbF8mOp99k20Meta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmKXc7Kh_45XYVTiu0hO4Uipqs9rK_wAULmZEsdvl_8YmxAMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmA_45haJh7PnJfDul6lJwNz2Dp_BveWRkMstZsetaKqhsMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_454fZSef0JT9Izlz2YhQN2XK0NuL2hhyys1rkMovYeQcMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register_N4gBgVddK1U_45OWFrJgPY82ZPGK2wcTNbIWIxBMuZ40Meta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmgGn0VbcT0GXSTWEjWQx4LA14IAK6yK6Va6IQX6yjw4MMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code_ZfFj9i9lHSUpg0xoKH6_Kh6WqYKjozrJe4NdvIH9dsMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code6QtV3rDi7u9TuRkfFtCvuWTKZoMtVPZMlf8f7rH0t5AMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeuo_45mQSJWMUF58FaR9bSGP36HMcf1vsZDnb2VZijaytIMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerADvBt7hOATTG4zdOIQbYBrD9u_45und9YZUpigJzq34CYMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm3zqtq04YhxTSbEMpcTlc0LEacvERPS5F17RqyKH4P8MMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completevOl4LcDymjcGTAplcgqHwMy8xXmh3NeqI4pJwMlviDsMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index_45i1zlKVAP9QTmWqrOJ_45D1J1J4G6_45P49_45qrZw0Qi7D2EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeURMQxdIfxocwip6zjuDeIPd4jieQvkRjdZWC36A82NIMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplexiomCDIolxo2E513RsRCGkD4SIafxIPlHwCpJmBIJFQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailsR09XGaXMfUQrQJq2N4w_45T0n8oqhuO_457zk6O_45RNra6oMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm2GN5W2MREjnunlY5N5bHqJVh9nO2ieFQANGX3INiKF4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentgq_45eP4DqaEPYiAJkp9MRSOWX43RpDKjsUVyVfWTOjs0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_pwFbe82EDgHsX4qeYi43PqcLTUsFr7M3i4_45sIebWFQMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeBlQggwpRFnouWc8RIwRsGYdYjL9HQ1NkJRZhsVE_u08Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeSb2TJIv7ciXPaQZxFhLqju9uyL7zkWAD8fHQT7whhJgMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordB1bWqXni5aFD3hT9qnSnGPw1dyo3nzENn6fLVfjaCxcMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src218338103/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register4go_7uivi3GDLwQMajzZkkd6wm2hirVZRGeV46yNCOMMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeKM_9Hr_45GbdCeqAk_VQ2cANkcXkdZuHi17V_45w_45KlSs0kMeta || {},
    component: () => import("/codebuild/output/src218338103/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src218338103/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src218338103/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]